/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/utility/identity.js
 ** module id = 358
 ** module chunks = 0
 **/